import React from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, Routes } from "react-router-dom";
import { HeaderProvider } from './components/HeaderContext';
import { AlertProvider } from './components/AlertContext.jsx';
import { AlertMessage } from './components/AlertMessage.jsx';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import { AuthProvider } from './context/AuthProvider';
import Root from './Root';
import ErrorPage from "./components/ErrorPage";
import Login from './components/Login';
import RequireAuth from "./components/RequireAuth.js";
import PersistLogin from "./components/PersistLogin.js";
import Unauthorized from './components/Unauthorized.js';

// Import your components
import Users from "./pages/users/users.js";
import UsersAdd from "./pages/users/users_add.js";
import UsersEdit from "./pages/users/users_edit.js";
import Groups from "./pages/groups/groups.js";
import GroupsAdd from "./pages/groups/groups_add.js";
import GroupsEdit from "./pages/groups/groups_edit.js";

import Products from "./pages/products/products.jsx";
import ProductsView from "./pages/products/products_view.jsx";

import TestOrders from "./pages/test_orders/test_orders.jsx";
import TestOrdersEdit from "./pages/test_orders/test_orders_edit.jsx";

import GroupPermissions from "./pages/groups/group_permissions.js";

import PurchaseOrders from "./pages/purchase_orders/purchase_orders.js";
import PurchaseOrdersEdit from "./pages/purchase_orders/purchase_orders_edit.js";

import Suppliers from "./pages/suppliers/suppliers.js";

import BusinessDocuments from "./pages/business_documents/business_documents.jsx";

import Lots from "./pages/lots/lots.jsx";
import LotsEdit from "./pages/lots/lots_edit.jsx";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Root />} errorElement={<ErrorPage />}>

        {/* protected routes */}
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedGroups={["supplier", "admin"]} />}>

            <Route path="/users" element={<Users />} />
            <Route path="/users_add" element={<UsersAdd />} />
            <Route path="/users_edit/:id" element={<UsersEdit />} />

            <Route path="/groups" element={<Groups />} />
            <Route path="/groups_add" element={<GroupsAdd />} />
            <Route path="/groups_edit/:id" element={<GroupsEdit />} />
            <Route path="/group_permissions" element={<GroupPermissions />} />

            <Route path="/purchase_orders" element={<PurchaseOrders />} />
            <Route path="/purchase_orders_edit/:id" element={<PurchaseOrdersEdit />} />

            <Route path="/suppliers" element={<Suppliers />} />

            <Route path="/business_documents" element={<BusinessDocuments />} />

            <Route path="/lots" element={<Lots />} />
            <Route path="/lots_edit/:id" element={<LotsEdit />} />


            <Route path="/products" element={<Products />} />
            <Route path="/products_view/:id" element={<ProductsView />} />

            <Route path="/test_orders" element={<TestOrders />} />
            <Route path="/test_orders_edit/:id" element={<TestOrdersEdit />} />

          </Route>

          <Route element={<RequireAuth allowedGroups={["admin"]} />}>

          </Route>
        </Route>
        {/* Add other routes here */}
      </Route>

      {/* public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />


    </>
  )
);

const App = () => {
  return (
    <AuthProvider>
      <HeaderProvider>
        <AlertProvider>
          <RouterProvider router={router} />
          <NotificationContainer />
          <AlertMessage />
        </AlertProvider>
      </HeaderProvider>
    </AuthProvider>
  );
}

export default App;
